// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import contextMenu from './modules/contextMenu'
import demo from './modules/demo'
import labels from './modules/labels'
import mediaExportJobs from './modules/mediaExportJobs'
import onboarding from './modules/onboarding'
import planner from './modules/planner'
import presenceManagement from './modules/presenceManagement'
import postCreator from './modules/postCreator'
import selectPage from './modules/selectPage'
import storification from './modules/storification'
import templates from './modules/templates'
import templateFolders from './modules/templateFolders'
import tooltip from './modules/tooltip'
import tours from './modules/tours'
import ui from './modules/ui'
import users from './modules/users'
import variables from './modules/variables'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    selectPage,
    tooltip,
    contextMenu,
    demo,
    labels,
    mediaExportJobs,
    postCreator,
    storification,
    users,
    planner,
    presenceManagement,
    onboarding,
    templates,
    templateFolders,
    tours,
    ui,
    variables
  }
})
